import { render } from "./ProductsInquiry.vue?vue&type=template&id=5388d690&scoped=true&bindings={}"
import script from "./ProductsInquiry.vue?vue&type=script&lang=ts"
export * from "./ProductsInquiry.vue?vue&type=script&lang=ts"

import "./ProductsInquiry.vue?vue&type=style&index=0&id=5388d690&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5388d690"

export default script